import { createModel } from '@rematch/core'
import { RootModel } from '@stores'

import { TBanksState } from '../types/TBanksState'

export const banks = createModel<RootModel>()({
  state: {} as TBanksState,
  reducers: {
    set(state, payload: TBanksState) {
      return { ...state, ...payload }
    },
  },
  effects: (dispatch) => ({
    init(payload: TBanksState) {
      dispatch.banks.set(payload)
    },
  }),
})
